// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"8d9f9e24","803":"e5418590","832":"2ab03899"}[chunkId] + ".css";
};